import * as types from "./actionTypes";
import axios from "axios";
import qs from "qs";

export const getEvents = specialsId => dispatch => {
  axios
    .get(process.env.REACT_APP_API_URL + "/specials/" + specialsId + "/events")
    .then(({ data }) => {
      return dispatch({
        type: types.EVENTS_GET,
        data
      });
    });
};

export const getMoreEvents = (specialsId, page) => dispatch => {
  axios
    .get(
      process.env.REACT_APP_API_URL +
        "/specials/" +
        specialsId +
        "/events" +
        `?page=${page}`
    )
    .then(({ data }) => {
      return dispatch({
        type: types.EVENTS_GET_MORE,
        data
      });
    });
};

export const postEvents = (specialsId, value) => dispatch => {
  axios
    .post(
      `${process.env.REACT_APP_API_URL}/specials/${specialsId}/events/`,
      qs.stringify(value)
    )
    .then(({ data }) => {
      return dispatch({
        type: types.EVENTS_POST,
        data,
        str: value
      });
    })
    .catch(err => console.log("TCL: err", err));
};

export const postMoreEvents = (specialsId, value) => dispatch => {
  axios
    .post(
      `${process.env.REACT_APP_API_URL}/specials/${specialsId}/events/`,
      qs.stringify(value)
    )
    .then(({ data }) => {
      return dispatch({
        type: types.EVENTS_POST_MORE,
        data
      });
    })
    .catch(err => err);
};



// WEBPACK FOOTER //
// ./src/modules/events/actions.js